import Styles from './styles.module.css';
import Logo from '../../../image/home/logo_white.png';
import { DOC_DOWNLOAD_URL, CONSULT_URL, SCHOOL_LOGIN_URL, STUDENT_APP_URL } from '../_config';

const SchoolFooter = () => {
  return (
    <footer className={Styles.footer}>
      <div className={Styles.inner}>
        <div className={Styles.left}>
          <img src={Logo} alt="memorii works" />
          <p>
            株式会社memorii<br />
            〒220-0072 神奈川県横浜市西区浅間町<br />
            1丁目4番3号 ウィザードビル402
          </p>
        </div>

        <div className={Styles.links}>
          <a href={CONSULT_URL}>求人票管理について相談する</a>
          <a href={DOC_DOWNLOAD_URL}>資料をダウンロード</a>
          <a href={SCHOOL_LOGIN_URL}>学校管理画面ログイン</a>
          <a href={STUDENT_APP_URL} target="_blank" rel="noopener noreferrer">学生向け就活アプリ</a>
          <a href="https://memorii-works.com/company">サロン様向けサービス</a>
          <a href="https://memorii-works.com/about">運営会社</a>
          <a href="https://memorii-works.com/terms-service">利用規約</a>
          <a href="https://memorii-works.com/policy-service">プライバシーポリシー</a>
        </div>
      </div>

      <div className={Styles.hr} />
      <p className={Styles.copy}>© 2026 memorii, Inc. All Rights Reserved.</p>
    </footer>
  );
};

export default SchoolFooter;
